module.exports = __webpack_public_path__ + "static/media/schf.53160adf.png";